import type { RequestOptions } from "../common/server";
import type { ActivityFeedListingJs, GetItemsForFilesystemRequest } from "@/generated/models";
import { server } from "./server";

export interface Filter {
  untilTime?: Date;
  afterTime?: Date;
  highlightsOnly?: boolean;
}

export async function getItemsForFilesystem(workspaceId: string, filter?: Filter, { signal }: RequestOptions = {}) {
  const params: GetItemsForFilesystemRequest = {
    UntilTime: filter?.untilTime?.toISOString(),
    AfterTime: filter?.afterTime?.toISOString(),
    HighlightsOnly: filter?.highlightsOnly || undefined,
  };
  const response = await server.get("feed/getItemsForFilesystem", {
    signal,
    searchParams: {
      filesystemId: workspaceId,
      ...params,
    },
  });
  return await response.json() as ActivityFeedListingJs;
}
